import { faArrowLeft, faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Autocomplete, Box, Button, FormControl, MenuItem, OutlinedInput, Select, TextField } from '@mui/material'
import dayjs from 'dayjs'
import React, { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import Page from '../../component/Page'
import { getBranchList, getBudgetYearList, getItemMasterList, getTypesList } from '../setting/services/settingApi'
import PlanContext from './services/planApi'
import api from '../../api/api'
import { PLAN_CONFIG } from './config'
import ConfirmDialogPlanproduction from './component/confirmDialogPlanproduction'
import ConfirmPlanPrint from './component/confirmPlanPrint'
import Swal from 'sweetalert2'

export default function ViewProductionPlan() {
    const { id } = useParams()
    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams()
    let mode = searchParams.get('mode') || ''
    let version = searchParams.get('version') || ''
    const { profile, loading } = useSelector(state => state.profile)
    const { getPlanProductioDetail, getPlanProductionReasons } = useContext(PlanContext);
    const [branchs, setBranchs] = useState([])
    const [year, setYear] = useState([])
    const [selectYear, setSelectYear] = useState()
    const [selectSeasons, setSelectSeasons] = useState()
    const [remark, setRemark] = useState('')
    const [BranchNo, setBranchsNo] = useState('')
    const [refNo, setRefNo] = useState()
    const [open, setOpen] = useState(false)
    const [openP, setOpenP] = useState(false)
    const [detail, setDetail] = useState()
    const [items, setItems] = useState([])
    const [name, setName] = useState('')
    const [seasons, setSeasons] = useState([])
    const [type, setType] = useState([])
    const [reasons, setReasons] = useState([])
    const [refNoError, setrefNoError] = useState(false)
    const [yearError, setyearError] = useState(false)
    const [seasonsError, setseasonsError] = useState(false)
    const [rows, setRows] = useState([
        {
            TypeNo: "",
            GroupNo: "",
            CatalogNo: "",
            InitialTarget: 0,
            UpdateTarget: 0,
            ReasonId: 0,
            ReasonOther: ""
        }
    ]);
    function addRow() {
        const newRow = {
            TypeNo: "",
            GroupNo: "",
            CatalogNo: "",
            InitialTarget: 0,
            UpdateTarget: 0,
            ReasonId: 0,
            ReasonOther: ""
        };

        setRows([...rows, newRow]);
    }
    const deletehand = (i) => {
        const data = rows?.filter((e, index) => i !== index);
        setRows(data);
    };
    useEffect(() => {
        if (id) {
            getPlanProductioDetail(id, version, setDetail)
            getPlanProductionReasons(setReasons)
        }
        getBranchList(null, setBranchs)
        setBranchsNo(profile?.BranchNo?.BranchNo)
        getBudgetYearList(setYear)
        getTypesList(null, setType)
    }, [])
    useEffect(() => {
        getItemMasterList(name, setItems)
    }, [name])
    useEffect(() => {
        if (detail) {
            setRefNo(detail?.RefNo)
            setRemark(detail?.Remark)
            setBranchsNo(detail?.BranchNo?.BranchNo)
            ChangeBudgetYear(+detail?.Year)
            setSelectSeasons(detail?.Season)
            setSelectYear(detail?.Year)
            setRows(detail?.PlanDetails?.map((x) => ({
                ...x,
                ItemNo: {
                    ItemName: x?.CatalogNo?.CatalogName + ' ' + x?.GroupNo?.GroupName,
                    CatalogNo: x?.CatalogNo,
                    GroupNo: x?.GroupNo,
                    Option1: x?.TypeNo?.TypeName,
                }
            })))
        }
    }, [detail])
    function ChangeBudgetYear(event) {
        const year = event
        if (year) {
            const rainYear = new Date(+year - 1, 0, 1);
            const dryYear = new Date((+year), 0, 1);
            setSeasons([
                {
                    value: 'ฝน',
                    year: rainYear.getFullYear()
                },
                {
                    value: 'แล้ง',
                    year: dryYear.getFullYear()
                }
            ])

        } else {
            setSeasons([])
        }

    }

    const handleSubmit = (status) => {
        const body = {
            DocumentNo: id || null,
            BranchNo: BranchNo,
            RefNo: refNo,
            DocumentDate: dayjs(new Date()).format('YYYY-MM-DD'),
            Year: selectYear,
            Season: selectSeasons,
            Remark: remark,
            PlanDetails: rows?.map((x) => ({
                ...x,
                CatalogNo: x?.CatalogNo?.CatalogNo || x?.CatalogNo,
                GroupNo: x?.GroupNo?.GroupNo || x?.GroupNo,
                TypeNo: x?.TypeNo?.TypeNo || x?.TypeNo,
            })),
            ReviewStatus: (mode === 'review' && (detail?.ReviewStatus === 'N' || detail?.ReviewStatus === 'Y' || detail?.ReviewStatus === 'D') && !version) ? 'W' : status

        }
        const planProductionAdd = async () => {


            if (id) {
                const DocNo = encodeURIComponent(body?.DocumentNo)
                const url = PLAN_CONFIG.requests.getPlanProduction.url + `/${DocNo}`;
                const res = await api.put(url, body)
                const data = res.data
                if (data.status === true) {
                    setOpen(false)
                    setOpenP(true)
                } else {
                    Swal.fire({
                        title: data?.message || 'ทำรายการไม่สำเร็จ',
                        icon: 'warning',
                    })
                }
            } else {

                const res = await api.post(PLAN_CONFIG.requests.getPlanProduction.url, body)
                const data = res.data
                if (data.status === true) {
                    
                    navigate('/plan/production-plan/' + data.result.DocumentNo)

                    setOpen(false)
                    setOpenP(true)
                } else {
                    Swal.fire({
                        title: data?.message || 'ทำรายการไม่สำเร็จ',
                        icon: 'warning',
                    })
                }
            }

        }
        planProductionAdd()

    }

    return (
        <div style={{ padding: '10px 30px' }}>
            <Page>
                <form>
                    <div class="container-fluid">
                        <div class="d-flex row align-items-center ">
                            <div class="col-6">
                                <label class="title-content mb-4">
                                    {mode === 'review' ? 'ทบทวนแผนการผลิต' : 'ข้อมูลแผนการผลิต'}
                                </label>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-md-12">
                                <label class="labelInput">เลขที่หนังสือ</label>
                                <Box className={`backgroundField ${refNoError ? 'error' : ''}`} >
                                    <TextField value={refNo} onChange={e => setRefNo(e.target.value)} variant="standard" fullWidth onBlur={e => {
                                        if (!e.target.value) {
                                            setrefNoError(true)
                                        } else {
                                            setrefNoError(false)
                                        }
                                    }}
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                </Box>
                                {refNoError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณากรอกเลขที่หนังสือ</span>}

                            </div>


                            <div class="col-lg-4 col-md-12">
                                <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <FormControl variant="standard" fullWidth >
                                        <Select value={BranchNo || ''} onChange={e => setBranchsNo(e.target.value)} disableUnderline >
                                            {branchs?.map((x) => (
                                                <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                            </div>


                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-md-6">

                                <label class="labelInput">ปีงบประมาณ</label>
                                <Box className={`backgroundField ${yearError ? 'error' : ''}`}>
                                    <FormControl variant="standard" fullWidth >
                                        <Select value={selectYear || ''} onChange={e => {
                                            setSelectYear(e.target.value)
                                            ChangeBudgetYear(+e.target.value)
                                        }} disableUnderline onBlur={e => {
                                            if (!e.target.value) {
                                                setyearError(true)
                                            } else {
                                                setyearError(false)
                                            }
                                        }} >
                                            {year?.map((x) => (
                                                <MenuItem value={x?.BudgetYear}>{x?.BudgetYear}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                                {yearError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณาเลือกปีงบประมาณ</span>}

                            </div>
                            <div class="col-lg-4 col-md-6">

                                <label class="labelInput">ฤดู</label>
                                <Box className={`backgroundField ${seasonsError ? 'error' : ''}`}>
                                    <FormControl variant="standard" fullWidth >
                                        <Select value={selectSeasons || ''} onChange={e => setSelectSeasons(e.target.value)} disableUnderline onBlur={e => {
                                            if (!e.target.value) {
                                                setseasonsError(true)
                                            } else {
                                                setseasonsError(false)
                                            }
                                        }}>
                                            {seasons?.map((x) => <MenuItem value={x?.value}>{`${x?.value} ${x?.year}`}</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </Box>
                                {seasonsError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณาเลือกฤดู</span>}

                            </div>



                        </div>
                        {id &&
                            <div class="row">
                                <div class="col-lg-4 col-md-6">
                                    <label class="labelInput me-3">ผู้สร้าง</label> <label class="message-error-label">( {dayjs(detail?.CreateDate).format('DD/MM/BBBB')} )</label>
                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                        <TextField disabled value={detail?.CreateId} variant="standard" fullWidth
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />
                                    </Box>
                                </div>
                                <div class="col-lg-4 col-md-6">
                                    <label class="labelInput me-3">ผู้แก้ไข</label> <label class="message-error-label">
                                        ( {dayjs(detail?.ModifiedDate).format('DD/MM/BBBB')} )

                                    </label>
                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                        <TextField disabled value={detail?.ModifiedId} variant="standard" fullWidth
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />
                                    </Box>
                                </div>
                            </div>
                        }
                        <div class="row">
                            <div class="col-lg-8 col-md-12">
                                <label class="labelInput">หมายเหตุ</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px',borderRadius:"25px" }}>
                                    <TextField value={remark} onChange={e => setRemark(e.target.value)} variant="standard" fullWidth multiline rows={3}
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                </Box>
                            </div>
                        </div>


                        <div class="d-flex row align-items-center  mt-5 mb-4">
                            <div class="col-6">
                                <label class="title-content">
                                    {mode === 'review' ? 'รายการทบทวนแผนการผลิต' : 'รายการแผนการผลิต'}
                                </label>
                            </div>
                            {/* <div class="col-6 text-end">
                                <FontAwesomeIcon icon={faPlusCircle} onClick={addRow} />

                            </div> */}
                        </div>
                        <div class="row">
                            <div class="col-md-12 table-responsive-sm pb-3" style={{ height: 'auto' }}>
                                <table class="table table-borderless table-hover ">
                                    <thead>
                                        <tr>
                                            <th scope="col ">ที่</th>
                                            <th scope="col ">เมล็ดพันธุ์</th>
                                            <th scope="col ">ชนิดข้าว</th>
                                            <th scope="col ">ปริมาณ (กิโลกรัม)</th>
                                            {mode === 'review' && <th scope="col ">ทบกวน (กิโลกรัม)</th>}
                                            {mode === 'review' && <th scope="col ">เหตุผล</th>}


                                            <th scope="col"></th>

                                        </tr>
                                    </thead>
                                    <tbody class="">
                                        {rows.map((x, i) => (
                                            <tr >
                                                <td class="text-center">{i + 1}</td>

                                                <td>
                                                    <Autocomplete
                                                        size='small'
                                                        readOnly={id ? true : false}
                                                        options={items}
                                                        getOptionLabel={(option) => option?.ItemName}
                                                        componentsProps={{
                                                            paper: {
                                                                sx: {
                                                                    width: 500
                                                                }
                                                            }
                                                        }}
                                                        renderOption={(props, option) => (
                                                            <Box component="li" {...props} key={option.ItemNo}>
                                                                {option?.CatalogNo?.CatalogName} {option?.Option1} 
                                                            </Box>
                                                        )}
                                                        value={x?.ItemNo || null}
                                                        onChange={(event, newValue) => {

                                                            const item = rows?.map((v, index) => {

                                                                // v.LotGen = v?.id === x?.id ? lotNumber : v?.LotGen;
                                                                v.ItemNo = i === index ? newValue : v?.ItemNo;
                                                                v.TypeNo = i === index ? type?.find((y) => y?.TypeName === newValue?.Option1)?.TypeNo : v?.TypeNo
                                                                v.GroupNo = i === index ? newValue?.GroupNo?.GroupNo : v?.GroupNo
                                                                v.CatalogNo = i === index ? newValue?.CatalogNo?.CatalogNo : v?.CatalogNo
                                                                return v;

                                                            });
                                                            setRows([...item]);

                                                        }}

                                                        renderInput={(params) => (
                                                            <Box ref={params.InputProps.ref}>
                                                                <OutlinedInput {...params.inputProps} fullWidth size='small' sx={{ padding: '0 !important' }} />
                                                            </Box>
                                                        )}
                                                    />
                                                </td>
                                                <td class="text-center">{type?.find((y) => y?.TypeName === x?.ItemNo?.Option1)?.TypeName}</td>

                                                <td class="text-center">
                                                    <TextField value={x?.InitialTarget} size='small' fullWidth variant='outlined' onChange={e => {
                                                        const item = rows?.map((v, index) => {
                                                            v.InitialTarget = i === index ? e.target.value : v?.InitialTarget;
                                                            return v;

                                                        });
                                                        setRows([...item]);
                                                    }} />
                                                </td>
                                                {mode === 'review' &&
                                                    <td class="text-center">
                                                        <TextField value={x?.UpdateTarget} size='small' fullWidth variant='outlined' onChange={e => {
                                                            const item = rows?.map((v, index) => {
                                                                v.UpdateTarget = i === index ? e.target.value : v?.UpdateTarget;
                                                                return v;

                                                            });
                                                            setRows([...item]);
                                                        }} /></td>}
                                                {mode === 'review' && <td class="text-center">
                                                    <FormControl variant="outlined" size='small' fullWidth >
                                                        <Select value={x?.ReasonId || '-'} onChange={e => {
                                                            const item = rows?.map((v, index) => {
                                                                v.ReasonId = i === index ? e.target.value === '-' ? '' : e.target.value : v?.ReasonId;
                                                                return v;

                                                            });
                                                            setRows([...item]);
                                                        }}  >
                                                            <MenuItem value='-'>-</MenuItem>
                                                            {reasons?.map((z, i) => (
                                                                <MenuItem value={z?.ReasonId}>{z?.ReasonName}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </td>}
                                                <td>
                                                    {/* <FontAwesomeIcon icon={faMinusCircle} onClick={() => deletehand(i)} /> */}

                                                </td>


                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>


                        </div>
                        <hr class="chr" />
                        <div class="row mt-4">

                            <div class="col-12 ">
                                <Button variant='outlined' onClick={() => navigate(-1)} startIcon={<FontAwesomeIcon icon={faArrowLeft} />} sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
                                {version ?
                                    (mode === 'review' && detail?.ReviewStatus === 'W') || (mode === 'plan' && detail?.ReviewStatus === 'Y') ?
                                        <Button variant='contained' sx={{ width: '130px', fontSize: '14px' }} onClick={() => {
                                            if (!refNo) {
                                                setrefNoError(true)
                                            }

                                            if (!selectYear) {
                                                setyearError(true)
                                            }
                                            if (!selectSeasons) {
                                                setseasonsError(true)
                                            }

                                            if (refNo && selectYear && selectSeasons) {
                                                setOpen(true)

                                            }
                                        }}>{mode === 'plan' && id ? 'เเก้ไข' : 'บันทึก' || mode === 'review' && detail?.ReviewStatus === 'N' ? 'ทบทวนแผน' : '' || mode === 'review' && detail?.ReviewStatus === 'W' ? 'แก้ไขแผนทบทวน' : ''}</Button> : null

                                    : null}
                                {!version && (detail?.ReviewStatus === 'W' || detail?.ReviewStatus === 'Y' || detail?.ReviewStatus === 'N' || detail?.ReviewStatus === 'D') || !detail ? <>
                                    {mode === 'plan' &&
                                        <Button variant='contained' sx={{ width: '150px', fontSize: '14px' }} onClick={() => {
                                            if (!refNo) {
                                                setrefNoError(true)
                                            }

                                            if (!selectYear) {
                                                setyearError(true)
                                            }
                                            if (!selectSeasons) {
                                                setseasonsError(true)
                                            }

                                            if (refNo && selectYear && selectSeasons) {
                                                setOpen(true)

                                            }
                                        }}>{id ? 'เเก้ไข' : 'บันทึก'}</Button>
                                    }
                                    {
                                        mode === 'review' &&

                                        <Button variant='contained' sx={{ width: '150px', fontSize: '14px' }} onClick={() => {
                                            if (!refNo) {
                                                setrefNoError(true)
                                            }

                                            if (!selectYear) {
                                                setyearError(true)
                                            }
                                            if (!selectSeasons) {
                                                setseasonsError(true)
                                            }

                                            if (refNo && selectYear && selectSeasons) {
                                                setOpen(true)

                                            }
                                        }}>{detail?.ReviewStatus === 'W' ? 'แก้ไขแผนทบทวน' : 'ทบทวนแผน'}</Button>}
                                </>
                                    : null 

                                }
                                {profile?.BranchNo?.BranchNo === '00' && <>
                                    {((detail && detail?.ReviewStatus === 'W') && mode === 'review') && <>
                                        <Button variant='contained' color='success' sx={{ width: '130px', fontSize: '14px', marginLeft: '10px' }} onClick={() => {
                                            Swal.fire({
                                                title: 'ยืนยันการอนุมัติ',
                                                icon: 'question',
                                                showCancelButton: true,
                                                confirmButtonColor: '#4ab866',
                                                cancelButtonColor: '#d33',
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    handleSubmit('Y')
                                                }

                                            })

                                        }}>อนุมัติ</Button>
                                        <Button variant='contained' color='error' sx={{ width: '130px', fontSize: '14px', marginLeft: '10px' }} onClick={() => {
                                            Swal.fire({
                                                title: 'ยืนยันการไม่อนุมัติ',
                                                icon: 'question',
                                                showCancelButton: true,
                                                confirmButtonColor: '#4ab866',
                                                cancelButtonColor: '#d33',
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    handleSubmit('D')
                                                }
                                            })
                                        }}>ไม่อนุมัติ</Button>
                                    </>}

                                </>}
                            </div>
                        </div>
                    </div>
                </form>
            </Page>
            <ConfirmDialogPlanproduction open={open} setOpen={setOpen} rows={rows} handleAdd={handleSubmit} mode={mode} reasons={reasons} />
            <ConfirmPlanPrint title={mode === 'plan' ? 'บันทึกรายการแผนการผลิตสำเร็จ' : 'บันทึกรายการแผนการแผนการทบทวนสำเร็จ'} download={null} open={openP} setOpen={setOpenP} loadingPDF={null} linkTo='/plan/production-plan/add' />
        </div >
    )
}
